import React, { createContext, useContext, useState, useEffect } from 'react';

const IdentityContext = createContext();

export const IdentityProvider = ({ children }) => {
  const [anonId] = useState(() => {
    let id = localStorage.getItem('sg_anon_id');
    if (!id) {
      id = 'anon_' + Math.random().toString(36).substring(2, 15) + Date.now().toString(36);
      localStorage.setItem('sg_anon_id', id);
    }
    return id;
  });

  return (
    <IdentityContext.Provider value={{ anonId }}>
      {children}
    </IdentityContext.Provider>
  );
};

export const useIdentity = () => {
  const context = useContext(IdentityContext);
  if (!context) throw new Error('useIdentity must be used within IdentityProvider');
  return context;
};

export default IdentityContext;
